<template>
    <div></div>
    <v-spacer></v-spacer>
    <div class="user-container mr-3" data-cy="unauthorised-app-bar">
        <!-- user logo -->
        <v-img class="user-logo" :src="userPicture"></v-img>
        <!-- user details -->
        <div class="user-details-container">
            <div
                data-cy="userName"
                class="user-name body-medium white-text mt-2"
            >
                {{ userName }}
            </div>
        </div>
        <!-- settings button -->
        <div class="settings-container">
            <icon-button
                data-cy="userMenuButton"
                btn-style="default-btn medium-icon-btn transparent-btn"
                :icon="mdiLogout"
                @run-method="handleLogout()"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { usePiniaStore } from "@/stores/store";
import { useOrganisationStore } from "@/stores/organisationStore";
import { signOut } from "aws-amplify/auth";

import iconButton from "@/components/buttons/iconButton.vue";
import { redirectToRoute } from "@/router";
import { AuthRouteNames } from "@/constants/routes";
import { mdiLogout } from "@mdi/js";

const pStore = usePiniaStore();
const organisationStore = useOrganisationStore();

// get user details
const userPicture = computed(() => "");
const userName = computed(() => pStore.getUserEmail);

// logs user out
const handleLogout = async () => {
    pStore.setIsAuthenticated(false);
    try {
        await signOut({ global: true });
    } finally {
        organisationStore.clearOrganisationContext(pStore.getUserEmail);
        redirectToRoute({ name: AuthRouteNames.LOGIN });
    }
};
</script>
